import './AttachmentView.css';
import { jsxs as g, jsx as t } from "react/jsx-runtime";
import s from "clsx";
import L from "react";
import { EAttachmentStatus as e } from "./attachment.mjs";
import "./usePageLifecycle.consts.mjs";
import { truncateMiddle as O } from "./truncateMiddle.mjs";
import "./getCentsSeparatorByCurrencyCode.mjs";
import "./getCurrencyCodeBySymbol.mjs";
import "./getCurrencyCodeFromString.mjs";
import "./getCurrencyCodeRTL.mjs";
import "./getCurrencySymbolByCode.mjs";
import "./getCurrencySymbolPlaceByCode.mjs";
import "./getCurrencySymbolSeparatorByCode.mjs";
import "big.js";
import "./getSeparatorByCurrencyCode.mjs";
import "./stringToBigFormat.mjs";
import "./moneyUtils.consts.mjs";
import { b as f, S as h, a as D, c as b, d as G } from "./loading-CqMDl6K7.js";
import { S as I } from "./no-preview-D-KUNa8H.js";
const S = "_wrapper_uwqls_1", W = "_leftIcon_uwqls_27", q = "_clipIcon_uwqls_32", U = "_alertIcon_uwqls_35", V = "_previewWrapper_uwqls_39", k = "_fileName_uwqls_61", C = "_crossWrapper_uwqls_67", M = "_withoutPreviewImage_uwqls_77", F = "_isMobile_uwqls_83", T = "_uploadingError_uwqls_89", x = "_previewError_uwqls_89", B = "_uploading_uwqls_89", y = "_previewLoading_uwqls_104", j = "_errorAlert_uwqls_107", H = "_warningAlert_uwqls_111", X = "_clickable_uwqls_115", r = {
  wrapper: S,
  leftIcon: W,
  clipIcon: q,
  alertIcon: U,
  previewWrapper: V,
  fileName: k,
  crossWrapper: C,
  withoutPreviewImage: M,
  isMobile: F,
  uploadingError: T,
  previewError: x,
  uploading: B,
  previewLoading: y,
  errorAlert: j,
  warningAlert: H,
  clickable: X
}, E = 20, z = [e.UPLOADING, e.PREVIEW_LOADING], J = ({ status: _, previewImageUrl: c, onClick: a, alert: o, withoutPreviewImage: p }) => {
  const i = o ? /* @__PURE__ */ t(
    "div",
    {
      className: s({
        [r.leftIcon]: !0,
        [r.alertIcon]: !0
      }),
      title: o.alertText,
      children: /* @__PURE__ */ t(h, {})
    }
  ) : null;
  if (p)
    return i || /* @__PURE__ */ t(
      "div",
      {
        className: s({
          [r.leftIcon]: !0,
          [r.clipIcon]: !0
        }),
        children: /* @__PURE__ */ t(D, {})
      }
    );
  let l = /* @__PURE__ */ t("img", { src: c, alt: "" });
  switch (c || (l = /* @__PURE__ */ t(I, {})), _) {
    case e.UPLOADING:
    case e.PREVIEW_LOADING: {
      l = /* @__PURE__ */ t(G, {});
      break;
    }
    case e.PREVIEW_ERROR: {
      l = /* @__PURE__ */ t(I, {});
      break;
    }
    case e.UPLOADING_ERROR: {
      l = /* @__PURE__ */ t(b, {});
      break;
    }
  }
  return /* @__PURE__ */ g(
    "button",
    {
      onClick: a,
      className: s({
        [r.previewWrapper]: !0,
        [r.clickable]: !!a
      }),
      children: [
        i,
        l
      ]
    }
  );
}, K = ({ status: _, name: c, onClick: a, dontWrapFileName: o, maxFileNameLength: p = E }) => {
  const i = () => {
    const l = !o && c ? O(c, p) : c;
    switch (_) {
      case e.UPLOADING:
        return "Uploading in progress...";
      case e.UPLOADING_ERROR:
        return l || "Failed to upload the file";
      case e.PREVIEW_LOADING:
        return l || "Loading...";
      case e.PREVIEW_ERROR:
        return "Failed to get the file data";
      default:
        return l;
    }
  };
  return /* @__PURE__ */ t(
    "button",
    {
      onClick: a,
      className: s({
        [r.fileName]: !0,
        [r.clickable]: !!a
      }),
      children: i()
    }
  );
}, Q = ({
  name: _,
  uuid: c,
  previewImageUrl: a,
  status: o,
  className: p,
  alert: i,
  withoutPreviewImage: l,
  dontWrapFileName: A,
  isMobile: v,
  maxFileNameLength: N = E,
  onClick: m,
  onCrossClick: w
}) => {
  const u = m && !(o === e.UPLOADING || o === e.UPLOADING_ERROR) ? (n) => {
    n == null || n.preventDefault(), n == null || n.stopPropagation(), m(c);
  } : void 0, d = w && o != e.UPLOADING ? (n) => {
    n == null || n.preventDefault(), n == null || n.stopPropagation(), w(c);
  } : void 0, R = s({
    [r.wrapper]: !0,
    // Statuses
    [r.uploading]: o === e.UPLOADING,
    [r.uploadingError]: o === e.UPLOADING_ERROR,
    [r.previewLoading]: o === e.PREVIEW_LOADING,
    [r.previewError]: o === e.PREVIEW_ERROR,
    [r.previewSuccess]: o === e.PREVIEW_SUCCESS,
    [r.downloading]: o === e.DOWNLOADING,
    // Alert
    [r.warningAlert]: (i == null ? void 0 : i.type) === "warning",
    [r.errorAlert]: (i == null ? void 0 : i.type) === "error",
    // Mobile
    [r.isMobile]: v,
    [r.withoutPreviewImage]: l,
    // Custom classes
    [String(p)]: !!p
  }), P = w && !z.includes(o);
  return /* @__PURE__ */ g("div", { className: R, children: [
    /* @__PURE__ */ t(
      J,
      {
        status: o,
        previewImageUrl: a,
        alert: i,
        onClick: u,
        withoutPreviewImage: l
      }
    ),
    /* @__PURE__ */ t(
      K,
      {
        status: o,
        name: _,
        onClick: u,
        maxFileNameLength: N,
        dontWrapFileName: A
      }
    ),
    P ? /* @__PURE__ */ t(
      "button",
      {
        onClick: d,
        className: s({
          [r.crossWrapper]: !0,
          [r.clickable]: !!d
        }),
        children: /* @__PURE__ */ t(f, {})
      }
    ) : null
  ] });
}, Ir = L.memo(Q);
export {
  Ir as A
};
//# sourceMappingURL=AttachmentView-CgsYQoZZ.js.map
